
// === Debug helpers & fetch interceptor ===
function safeStringify(obj, maxLen = 400) {
    return JSON.stringify(obj, (k, v) => {
        if (typeof v === 'string' && v.length > maxLen) return v.slice(0, maxLen) + `… (+${v.length - maxLen} chars)`;
        return v;
    }, 2);
}

function logGroup(label, payload) {
    console.groupCollapsed(`🧭 ${label}`);
    try { console.log(safeStringify(payload)); } catch (e) { console.log(payload); }
    console.groupEnd();
}

(function() {
    const _fetch = window.fetch;
    window.fetch = async function(input, init) {
        const url = typeof input === 'string' ? input : input.url;
        const body = init && init.body ? init.body : null;

        console.groupCollapsed(`➡️ fetch ${url}`);
        if (body) {
            try { console.log('request body:', typeof body === 'string' ? body : safeStringify(body)); } catch(e) {}
        } else {
            console.log('request body: (none)');
        }
        console.groupEnd();

        const res = await _fetch(input, init);
        const clone = res.clone();
        try {
            const text = await clone.text();
            console.groupCollapsed(`⬅️ response ${url} (${res.status})`);
            try { console.log(safeStringify(JSON.parse(text))); } catch { console.log(text); }
            console.groupEnd();
        } catch(e) {}

        return res;
    };
})();
// === End debug helpers ===


// adyen payment
let products = []
let shipping_method = []
let currentSession = null

// Get Adyen configuration from backend (passed via PHP template)
const adyenConfig = window.adyenConfig || {
    clientKey: '',
    environment: 'test',
    merchantAccount: '',
};

async function fetchAdyenSession(el) {
    // Get productId and quantity from DOM for express checkout
    const quantityInput = document.querySelector('input[name="quantity"]');
    const productId = el && el.dataset ? el.dataset.productId : null;
    const quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;
    products = [ { 'product_id': productId, quantity }];

    // Fetch default shipping method to include in session
    // Apple Pay token amount MUST match session amount exactly
    // We include a default shipping in the session, then callbacks only update the display
    console.log('Fetching default shipping for Adyen session');

    let defaultShipping = null;
    try {
        const shippingResponse = await fetch('/adyen/apple-shipping-contact-change', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': typeof getCookie === 'function' ? getCookie('csrfToken') : ''
            },
            body: JSON.stringify({ products })
        });
        const shippingData = await shippingResponse.json();
        // Use the first shipping method as default
        if (shippingData.shippingMethods && shippingData.shippingMethods.length > 0) {
            defaultShipping = shippingData.shippingMethods[0];
            console.log('Default shipping method:', defaultShipping);
        }
    } catch (err) {
        console.error('Error fetching default shipping:', err);
    }

    const body = JSON.stringify({
        products: products,
        shippingMethod: defaultShipping  // Include default shipping in session
    });

    const response = await fetch('/adyen/create-session', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': typeof getCookie === 'function' ? getCookie('csrfToken') : ''
        },
        body
    });

    let session;
    try {
        session = await response.json();
    } catch (e) {
        const text = await response.text();
        console.error('Create-session non-JSON response:', text);
        throw e;
    }

    return { session, defaultShipping };
}

const globalConfiguration = {
    session: {},
    environment: adyenConfig.environment,
    clientKey: adyenConfig.clientKey,
    onPaymentFailed: (result, component) => {
        console.error('❌ Payment failed:', result, component);
        console.error('❌ Payment failed - Full error details:', JSON.stringify(result, null, 2));
        if (result && result.error) {
            console.error('❌ Error object:', result.error);
            console.error('❌ Error message:', result.error.message || result.error.errorMessage);
        }
    },
    onError: (error, component) => {
        console.error(error.name, error.message, error.stack, component);
    }
};

// Initialize Adyen Checkout from the global and mount the Card component
document.addEventListener('DOMContentLoaded', async function () {
    const isGoogleComponent = !!document.getElementById('googlepay-container');
    const express_element = document.getElementById('googlepay-container') || document.getElementById('applepay-container');

    // If express buttons are not rendered, don't event try to initialize
    if (!express_element) {
        return;
    }
    try {
        const { AdyenCheckout } = window.AdyenWeb;

        const { session, defaultShipping } = await fetchAdyenSession(express_element);
        currentSession = session; // Store initial session
        logGroup('Adyen SESSION (server)', session);

        const configuration = { ...globalConfiguration, session };
        configuration.countryCode = session.countryCode;
        configuration.currencyCode = session.currencyCode;
        configuration.locale = session.shopperLocale;
        logGroup('Checkout configuration (FE)', configuration);

        const checkout = await AdyenCheckout(configuration);
        logGroup('Checkout configuration (FE)', checkout);
        console.log('environment', checkout.options.environment);
        console.log("payments", checkout.paymentMethodsResponse)


        const isLive = (checkout.options && checkout.options.environment === 'live') || (globalConfiguration.environment === 'live');

        const sessionAmount = session.amount && session.amount.value ? session.amount.value : 0;
        const sessionAmountEuros = (sessionAmount / 100).toFixed(2); // Convert minor units to euros as string
        console.log('session amount (minor units):', sessionAmount);
        console.log('session amount (euros):', sessionAmountEuros);

        if (sessionAmount === 0) {
            console.error('⚠️ WARNING: Session amount is 0! Google Pay will show 0.00');
            console.log('📱 Default shipping used:', defaultShipping);
        }

        if (isGoogleComponent) {
            const { GooglePay } = window.AdyenWeb;
            const gpPm = checkout.paymentMethodsResponse.paymentMethods
                .find(pm => pm.type === 'googlepay');

            if (gpPm) {
                logGroup('📱 Google Pay payment method configuration', gpPm.configuration);
                const pmMerchantId = gpPm && gpPm.configuration ? gpPm.configuration.merchantId : undefined;
                const pmGatewayMerchantId = gpPm && gpPm.configuration ? gpPm.configuration.gatewayMerchantId : undefined;
                logGroup('📱 Google Pay merchant ID from Adyen', { merchantId: pmMerchantId, gatewayMerchantId: pmGatewayMerchantId });
                const resolvedMerchantId = pmMerchantId;
                logGroup('📱 Google Pay resolved merchant ID', { resolvedMerchantId, pmGatewayMerchantId, isLive });

                // Calculate amount from session (product + default shipping) - same as Apple Pay
                console.log('📱 Google Pay - Full session object:', session);
                console.log('📱 Google Pay - session.amount:', session.amount);

                const googlePayConfig = {
                    isExpress: true,
                    environment: adyenConfig.environment.toUpperCase(),  // Use dynamic environment from backend (TEST or LIVE)
                    buttonType: 'buy',
                    buttonColor: 'black',
                    paymentDataRequest: {
                        merchantInfo: {
                            merchantName: isLive ? 'Knifestock' : 'Knifestock Test'
                        }
                    },
                    // Explicitly allow all major card networks
                    allowedCardNetworks: ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'],
                    allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                    transactionInfo: {
                        countryCode: configuration.countryCode,
                        currencyCode: configuration.currencyCode,
                        totalPriceStatus: 'FINAL',
                        totalPrice: sessionAmountEuros,
                        totalPriceLabel: 'Total',
                    },
                    shippingAddressRequired: true,
                    shippingAddressParameters: {
                        allowedCountryCodes: [configuration.countryCode],
                        phoneNumberRequired: !!isLive
                    },
                    emailRequired: true,  // Require email instead
                    shippingOptionRequired: true,
                    callbackIntents: ['SHIPPING_ADDRESS', 'SHIPPING_OPTION', 'PAYMENT_AUTHORIZATION'],
                    paymentDataCallbacks: {
                        onPaymentDataChanged(intermediatePaymentData) {
                            logGroup('onPaymentDataChanged IN', intermediatePaymentData);
                            return new Promise((resolve) => {
                                const { callbackTrigger, shippingAddress } = intermediatePaymentData;
                                const requestData = {
                                    intermediatePaymentData,
                                    products,
                                    defaultShipping
                                };

                                const ALLOWED_CC = [configuration.countryCode];
                                if (shippingAddress && shippingAddress.countryCode && !ALLOWED_CC.includes(shippingAddress.countryCode)) {
                                    resolve({
                                        error: {
                                            reason: 'SHIPPING_ADDRESS_UNSERVICEABLE',
                                            message: 'Doručenie do vybranej krajiny nie je podporované',
                                            intent: 'SHIPPING_ADDRESS'
                                        }
                                    });
                                    return;
                                }

                                logGroup('📱 Google Pay shopper details (onPaymentDataChanged)', requestData);
                                fetch('/adyen/google-payment-change', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-CSRF-Token': typeof getCookie === 'function' ? getCookie('csrfToken') : ''
                                    },
                                    body: JSON.stringify(requestData)
                                })
                                    .then(function(res){ return res.json(); })
                                    .then(function(result){
                                        logGroup('📱 Google Pay backend response (google-payment-change)', result);
                                        logGroup('onPaymentDataChanged OUT', result);
                                        resolve(result || {});
                                    })
                                    .catch(function(err){
                                        console.error('📱 Google Pay onPaymentDataChanged error', err);
                                        resolve({});
                                    });
                            });
                        }
                    },
                    onSubmit: (state, component, actions) => {
                        console.log('🔧 Global onSubmit called', state);

                        const requestData = {
                            state,
                            products,
                            defaultShipping
                        };

                        return fetch('/adyen/google-submit-payment', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-CSRF-Token': typeof getCookie === 'function' ? getCookie('csrfToken') : ''
                            },
                            body: JSON.stringify(requestData)
                        })
                            .then(function(res) {
                                return res.json().then(function(result) {
                                    console.log('🔧 Backend onSubmit response:', result);

                                    if (result && result.success === true) {
                                        console.log('🔧 Backend onSubmit SUCCESS - resolving');
                                        actions.resolve({ transactionState: 'SUCCESS' });
                                        window.location.href = '/dokoncenie-objednavky?redirect=1';
                                    } else {
                                        const message = (result && result.message) || 'Payment failed';
                                        console.error('🔧 Backend onSubmit ERROR:', message);
                                        actions.reject({
                                            transactionState: 'ERROR',
                                            error: {
                                                intent: 'PAYMENT_AUTHORIZATION',
                                                message: message || 'Payment failed',
                                                reason: 'PAYMENT_DATA_INVALID'
                                            }
                                        });
                                    }
                                }).catch(function(jsonErr) {
                                    console.error('🔧 Backend onSubmit: response is not valid JSON', jsonErr);
                                    actions.reject({
                                        transactionState: 'ERROR',
                                        error: {
                                            intent: 'PAYMENT_AUTHORIZATION',
                                            message: 'Invalid response from server',
                                            reason: 'PAYMENT_DATA_INVALID'
                                        }
                                    });
                                });
                            })
                            .catch(function(err) {
                                console.error('🔧 Backend onSubmit error (network/exception)', err);
                                actions.reject({
                                    transactionState: 'ERROR',
                                    error: {
                                        intent: 'PAYMENT_AUTHORIZATION',
                                        message: (err && err.message) ? err.message : 'Network error',
                                        reason: 'PAYMENT_DATA_INVALID'
                                    }
                                });
                            });
                    },
                    onAuthorized(paymentData, actions) {
                        logGroup('📱 Google Pay onAuthorized - payment data', paymentData);
                        const email = paymentData && paymentData.authorizedEvent ? paymentData.authorizedEvent.email : null;
                        const phone = paymentData.authorizedEvent.phoneNumber ? paymentData.authorizedEvent.phoneNumber : paymentData.authorizedEvent.shippingAddress.phoneNumber;

                        const requestData = {
                            paymentData,
                            products,
                            email,
                            phone,
                            defaultShipping
                        };

                        // Wait for backend response before resolving
                        fetch('/adyen/google-authorize-payment', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-CSRF-Token': typeof getCookie === 'function' ? getCookie('csrfToken') : ''
                            },
                            body: JSON.stringify(requestData)
                        })
                            .then(function(res){
                                return res.json().then(function(result) {
                                    return { ok: res.ok, status: res.status, result: result };
                                });
                            })
                            .then(function(response){
                                logGroup('📱 Google Pay backend notification response', response);

                                if (response.ok && response.result && response.result.success === true) {
                                    console.log('GPay auth SUCCESS - backend validated, calling actions.resolve()');
                                    actions.resolve();
                                } else {
                                    const message = (response.result && response.result.message) || 'Backend validation failed';
                                    console.error('GPay auth ERROR:', message);
                                    actions.reject(message);
                                }
                            })
                            .catch(function(err){
                                console.error('📱 Google Pay backend notification error', err);
                                actions.reject((err && err.message) ? err.message : 'Network error');
                            });

                        // DO NOT return anything - let the promise above handle actions.resolve/reject
                    },
                    onError: (error) => {
                        console.groupCollapsed('💥 GooglePay onError');
                        console.error(error);
                        console.groupEnd();
                    }
                };

                // Set configuration object for Adyen gateway
                // According to Adyen support: merchantName, merchantId, and gatewayMerchantId must be in configuration
                if (isLive && resolvedMerchantId) {
                    googlePayConfig.configuration = {
                        merchantName: 'Knifestock',
                        merchantId: resolvedMerchantId,
                        gatewayMerchantId: pmGatewayMerchantId || adyenConfig.merchantAccount
                    };
                    console.log('📱 Google Pay - LIVE mode with configuration:', googlePayConfig.configuration);
                } else {
                    console.log('📱 Google Pay - TEST mode (no configuration object)');
                }

                const googlePay = new GooglePay(checkout, googlePayConfig);

                logGroup('📱 Google Pay final config', { isLive, pmMerchantId, resolvedMerchantId, origin: window.location.origin, checkoutEnv: checkout.options && checkout.options.environment });
                logGroup('📱 Google Pay component configuration', googlePayConfig);

                googlePay.mount('#googlepay-container');
                console.log('📱 Google Pay component mounted successfully');
            } else {
                console.warn('Google Pay nekdispozicii v tejto sessio. Je tam ', checkout.paymentMethodsResponse);
            }
        }

        // --- Apple Pay ---
        try {
            console.log("apple start")
            const { ApplePay } = window.AdyenWeb;
            const apPm = checkout.paymentMethodsResponse.paymentMethods
                .find(pm => pm.type === 'applepay');
            if (apPm && (!apPm.configuration || (!apPm.configuration.merchantIdentifier && !apPm.configuration.merchantId && !apPm.configuration.merchantID))) {
                console.warn('[ApplePay] paymentMethodsResponse.applepay missing merchantIdentifier. Check Customer Area → Merchant (ShadowSlovakiaECOM) → Payment methods → Apple Pay: set "Use Adyen\'s certificate (Managed)" and verify domains for', window.location.origin);
            }

            if (apPm) {
                // Apple Pay is only available on supported browsers/devices (Safari). Guard for support.
                const hasAPS = typeof window.ApplePaySession !== 'undefined';
                const canMakePayments = hasAPS && typeof window.ApplePaySession.canMakePayments === 'function' && window.ApplePaySession.canMakePayments();

                // Try to resolve merchant identifier from the payment method configuration if present.
                const apCfg = (apPm && apPm.configuration) ? apPm.configuration : {};
                const merchantIdentifier = apCfg.merchantIdentifier || apCfg.merchantId || apCfg.merchantID || undefined;

                async function canPayWithActiveCard() {
                    try {
                        if (hasAPS && typeof window.ApplePaySession.canMakePaymentsWithActiveCard === 'function' && merchantIdentifier) {
                            return await window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
                        }
                    } catch (e) {
                        console.groupCollapsed('ApplePay canMakePaymentsWithActiveCard error');
                        console.error(e);
                        console.groupEnd();
                    }
                    return false;
                }

                if (canMakePayments) {
                    if (!merchantIdentifier) {
                        console.warn('Apple Pay disabled – missing merchantIdentifier in paymentMethodsResponse (configure Apple Pay on the merchant account & verify domain).');
                        // Optionally hide the container to avoid a flash of a non-working button
                        const apContainer = document.querySelector('#applepay-container');
                        if (apContainer) apContainer.style.display = 'none';
                        return;
                    }
                    const hasActiveCard = await canPayWithActiveCard();
                    if (!hasActiveCard) {
                        console.warn('Apple Pay je dostupný, ale zariadenie nemá aktívnu kartu pre merchant identifier', merchantIdentifier || '(neznámy)');
                    }

                    // Calculate amount from session (product + default shipping)
                    console.log('🍎 Full session object:', session);
                    console.log('🍎 session.amount:', session.amount);

                    const sessionAmount = session.amount && session.amount.value ? session.amount.value : 0;
                    const sessionAmountEuros = sessionAmount / 100; // Convert minor units to euros
                    console.log('🍎 Apple Pay initializing with session amount (minor units):', sessionAmount);
                    console.log('🍎 Apple Pay session amount (euros):', sessionAmountEuros);

                    if (sessionAmount === 0) {
                        console.error('⚠️ WARNING: Session amount is 0! This will cause amount mismatch error.');
                        console.log('🍎 Default shipping used:', defaultShipping);
                    }

                    const applePay = new ApplePay(checkout, {
                        isExpress: true,
                        debug: true,
                        amount: { currency: configuration.currencyCode, value: sessionAmount },
                        countryCode: configuration.countryCode,
                        requiredBillingContactFields: ['postalAddress', 'name', 'phone', 'email'],
                        requiredShippingContactFields: ['postalAddress', 'name', 'phone', 'email'],
                        requiredShippingContact: ['phone', 'email'],
                        onShippingContactSelected: (resolve, reject, event) => {
                            console.log('🍎 Apple Pay shipping contact selected', event);

                            // Return the single default shipping method for display
                            // The price is already included in the session amount
                            resolve({
                                newTotal: {
                                    label: 'Total',
                                    amount: sessionAmountEuros,
                                    type: 'final'
                                },
                                newShippingMethods: defaultShipping ? [defaultShipping] : []
                            });
                        },
                        onShippingMethodSelected: (resolve, reject, event) => {
                            console.log('Apple Pay shopper details', event);
                            const { shippingMethod } = event;

                            // Store the selected shipping method immediately
                            shipping_method = [shippingMethod];

                            // CRITICAL: We MUST return newTotal but with the SAME session amount!
                            // The session was created with a default shipping cost
                            // The payment token amount CANNOT be changed after Apple Pay sheet opens
                            // We return the session amount to keep the display showing the same total
                            // The backend will receive the actual selected shipping in onAuthorized callback
                            console.log('🍎 Shipping method selected (stored for backend):', shippingMethod);
                            console.log('🍎 Returning session amount to keep display consistent:', sessionAmountEuros);

                            // Return the session amount (unchanged) to satisfy Apple Pay requirements
                            resolve({
                                newTotal: {
                                    label: 'Total',
                                    amount: sessionAmountEuros,
                                    type: 'final'
                                }
                            });
                        },
                        // === Insert onSubmit handler here ===
                        onSubmit: (state, component, actions) => {
                            console.log('🔧 Apple Pay Global onSubmit called', state);

                            const requestData = {
                                state,
                                products,
                                shipping_method: shipping_method.length > 0 ? shipping_method : (defaultShipping ? [defaultShipping] : [])
                            };

                            return fetch('/adyen/apple-submit-payment', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-CSRF-Token': typeof getCookie === 'function' ? getCookie('csrfToken') : ''
                                },
                                body: JSON.stringify(requestData)
                            })
                                .then(function(res) {
                                    return res.json().then(function(result) {
                                        console.log('🔧 Backend Apple onSubmit response:', result);

                                        if (result && result.success === true) {
                                            console.log('🔧 Backend Apple onSubmit SUCCESS - resolving');
                                            actions.resolve({ transactionState: 'SUCCESS' });
                                            window.location.href = '/dokoncenie-objednavky?redirect=1';
                                        } else {
                                            const message = (result && result.message) || 'Payment failed';
                                            console.error('🔧 Backend Apple onSubmit ERROR:', message);
                                            actions.reject({
                                                transactionState: 'ERROR',
                                                error: {
                                                    intent: 'PAYMENT_AUTHORIZATION',
                                                    message: message || 'Payment failed',
                                                    reason: 'PAYMENT_DATA_INVALID'
                                                }
                                            });
                                        }
                                    }).catch(function(jsonErr) {
                                        console.error('🔧 Backend Apple onSubmit: response is not valid JSON', jsonErr);
                                        actions.reject({
                                            transactionState: 'ERROR',
                                            error: {
                                                intent: 'PAYMENT_AUTHORIZATION',
                                                message: 'Invalid response from server',
                                                reason: 'PAYMENT_DATA_INVALID'
                                            }
                                        });
                                    });
                                })
                                .catch(function(err) {
                                    console.error('🔧 Backend Apple onSubmit error (network/exception)', err);
                                    actions.reject({
                                        transactionState: 'ERROR',
                                        error: {
                                            intent: 'PAYMENT_AUTHORIZATION',
                                            message: (err && err.message) ? err.message : 'Network error',
                                            reason: 'PAYMENT_DATA_INVALID'
                                        }
                                    });
                                });
                        },
                        // === End onSubmit handler ===
                        onAuthorized: ({ authorizedEvent, billingAddress, deliveryAddress }, actions) => {
                            console.log('🍎 Apple Pay onAuthorized (v6) - full authorizedEvent:', authorizedEvent);
                            console.log('🍎 Apple Pay billingAddress:', billingAddress);
                            console.log('🍎 Apple Pay deliveryAddress:', deliveryAddress);

                            // Extract email and phone from the authorizedEvent.payment object (v6 format)
                            const email = authorizedEvent && authorizedEvent.payment && authorizedEvent.payment.shippingContact ? authorizedEvent.payment.shippingContact.emailAddress : null;
                            const phone = authorizedEvent && authorizedEvent.payment && authorizedEvent.payment.shippingContact ? authorizedEvent.payment.shippingContact.phoneNumber : null;

                            console.log('🍎 Apple Pay extracted email:', email);
                            console.log('🍎 Apple Pay extracted phone:', phone);
                            console.log('🍎 Apple Pay shippingContact:', authorizedEvent && authorizedEvent.payment ? authorizedEvent.payment.shippingContact : null);

                            // Notify backend for order creation/tracking
                            const requestData = {
                                authorizedEvent,
                                billingAddress,
                                deliveryAddress,
                                email,
                                phone,
                                products,
                                shipping_method: shipping_method.length > 0 ? shipping_method : (defaultShipping ? [defaultShipping] : [])
                            };

                            // Wait for backend response before resolving (critical for LastOrderId session write)
                            fetch('/adyen/apple-authorize-payment', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                    'X-CSRF-Token': getCookie('csrfToken')
                                },
                                body: JSON.stringify(requestData)
                            })
                                .then(function(res){
                                    return res.json().then(function(result) {
                                        return { ok: res.ok, status: res.status, result: result };
                                    });
                                })
                                .then(function(response){
                                    console.log('🍎 Apple Pay backend notification response', response);

                                    if (response.ok && response.result && response.result.success === true) {
                                        console.log('🍎 Apple Pay auth SUCCESS - backend validated, calling actions.resolve()');
                                        actions.resolve();
                                    } else {
                                        const message = (response.result && response.result.message) || 'Backend validation failed';
                                        console.error('🍎 Apple Pay auth ERROR:', message);
                                        actions.reject(message);
                                    }
                                })
                                .catch(function(err){
                                    console.error('🍎 Apple Pay backend notification error', err);
                                    actions.reject((err && err.message) ? err.message : 'Network error');
                                });

                            // DO NOT return anything - let the promise above handle actions.resolve/reject
                        },
                        onError: (error) => {
                            console.groupCollapsed('boom ApplePay onError');
                            console.error('Full error object:', error);
                            if (error.message) console.error('Message:', error.message);
                            if (error.name) console.error('Name:', error.name);
                            console.groupEnd();
                        }
                    });

                    console.groupCollapsed('ApplePay config (resolved)');
                    try { console.log(safeStringify({ environment: checkout.options && checkout.options.environment, merchantIdentifier })); } catch (e) { console.log({ environment: checkout.options && checkout.options.environment, merchantIdentifier }); }
                    console.groupEnd();

                    try {
                        applePay.mount('#applepay-container');
                    } catch (mountErr) {
                        console.groupCollapsed('ApplePay mount error');
                        console.error(mountErr);
                        console.groupEnd();
                    }

                    // If the skeleton is still visible, remove it
                    const skeletonAP = document.getElementById('express-checkout-skeleton');
                    if (skeletonAP) skeletonAP.remove();
                } else {
                    console.warn('Apple Pay nie je podporovaný v tomto prehliadači/zariadení.');
                }

                // Debug helper: observe failed merchant validation calls in the console network logs.
                (function patchFetchForAppleValidation(){
                    if (!window.__applePayFetchPatched) {
                        window.__applePayFetchPatched = true;
                        const _f = window.fetch;
                        window.fetch = async function(input, init){
                            const url = typeof input === 'string' ? input : (input && input.url);
                            const res = await _f(input, init);
                            try {
                                if (url && /apple(pay)?/i.test(url) && res && !res.ok) {
                                    console.groupCollapsed('🍎 Apple Pay merchant validation/network error');
                                    console.log('URL:', url);
                                    console.log('Status:', res.status);
                                    const text = await res.clone().text();
                                    console.log('Body:', text);
                                    console.groupEnd();
                                }
                            } catch(_){}
                            return res;
                        }
                    }
                })();
            } else {
                console.warn('Apple Pay nie je k dispozícii v tejto session (paymentMethods).');
            }
        } catch (err) {
            console.groupCollapsed('ApplePay init error');
            console.error(err);
            console.groupEnd();
        }
        // If the skeleton is still visible, remove it and clear the timeout
        const skeleton = document.getElementById('express-checkout-skeleton');
        if (skeleton) {
            skeleton.remove();
        }
        clearTimeout(adyenSkeletonTimeout);
    } catch (e) {
        console.error('Failed to initialize Adyen Checkout', e);
    }
});

// Remove the skeleton if components take too long
var adyenSkeletonTimeout = setTimeout(function () {
    var skeleton = document.getElementById("express-checkout-skeleton");
    if (skeleton) {
        console.log("Removing Adyen skeleton after timeout");
        skeleton.remove();
    }
}, 7000);
